/* custom-checkbox-option.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import "./custom-checkbox-option.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { CheckboxOption } from '@atlaskit/select';
import Tooltip from '@atlaskit/tooltip';
var checkboxStyles = null;
var checkboxSelectedStyles = null;
var checkboxFocusedStyles = null;
export var CustomCheckboxOption = function CustomCheckboxOption(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: props.label
  }, /*#__PURE__*/React.createElement(CheckboxOption
  // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
  , _extends({}, props, {
    className: ax(["_189e1dm9 _1dqonqa1 _1h6d1j28 _16qsglyw _bfhk1j9a _1q511b66 _85i51b66 _bozgpxbi _y4tipxbi _irr31dpa _1di6fcek", props.isSelected && "_bfhk15s3 _irr3ufnl _1di6nozp", props.isFocused && "_1h6d1v1w"])
  }), children));
};